import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Input, Popover } from 'antd'
import { SearchOutlined, ClockCircleOutlined, FireOutlined, CloseOutlined } from '@ant-design/icons'
import { hotSearchRecord } from '@/api'
import styles from './Search.module.scss'


const SearchBarWithHistory = () => {

  const navigate = useNavigate()
  const [keyword, setKeyword] = useState('')
  const [hotList, setHotList] = useState([])
  const [history, setHistory] = useState([])
  const [showHistory, setShowHistory] = useState(false)

  const handleKeywordChange = (e) => {
    setKeyword(e.target.value)
  }

  const handleKeywordClick = (item) => {
    setKeyword(item)
    navigate('/search?keyword=' + item.trim())
  }

  const handleSearch = () => {
    console.log('handleSearch', keyword)
    if (keyword) {
      navigate('/search?keyword=' + keyword.trim())
      updateHistory(keyword.trim())
    }
  }

  const handleDelete = (field) => {
    const searchHistory = JSON.parse(localStorage.getItem('search_history') || '[]')
    const findIndex = searchHistory.findIndex(item => item === field)
    searchHistory.splice(findIndex, 1)
    const list = Array.from(new Set(searchHistory))
    setHistory(list.slice(0, 20))
    localStorage.setItem('search_history', JSON.stringify(list))
  }

  const updateHistory = (key) => {
    const searchHistory = JSON.parse(localStorage.getItem('search_history') || '[]')
    searchHistory.unshift(key)
    const list = Array.from(new Set(searchHistory))
    setHistory(list.slice(0, 20))
    localStorage.setItem('search_history', JSON.stringify(list.slice(0, 20)))
  }

  const getHotSearchRecord = async () => {
    try {
      const res = await hotSearchRecord()
      if (res.code === 0) {
        setHotList(res.data.map(item => item.keyword))
      } else {
        setHotList([])
      }
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    setHistory(JSON.parse(localStorage.getItem('search_history') || '[]'))
    getHotSearchRecord()
  }, [])

  const History = () => {
    if (!showHistory) return null

    return (
      <div className={styles.searchPanel}>
        {/* 搜索记录 */}
        <div className={styles.searchSection}>
          <div className={styles.sectionTitle}>
            <ClockCircleOutlined className={styles.titleIcon} />
            <span>搜索记录</span>
          </div>
          {history.length === 0 ? (
            <div className={styles.emptyItem}>暂无搜索记录</div>
          ) : (
            <div className={styles.itemList}>
              {history.slice(0, 6).map((item, index) => (
                <div
                  key={index}
                  className={styles.searchItem}
                  onClick={() => handleKeywordClick(item)}
                >
                  <span className={styles.itemText}>{item}</span>
                  <CloseOutlined
                    className={styles.closeIcon}
                    onClick={(e) => {
                      e.stopPropagation()
                      handleDelete(item)
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* 站内热门 */}
        <div className={styles.searchSection}>
          <div className={styles.sectionTitle}>
            <FireOutlined className={styles.titleIcon} />
            <span>站内热门</span>
          </div>
          {hotList && hotList.length === 0 ? (
            <div className={styles.emptyItem}>暂无热门搜索</div>
          ) : (
            <div className={styles.itemList}>
              {hotList.slice(0, 6).map((item, index) => (
                <div
                  key={index}
                  className={styles.searchItem}
                  onClick={() => handleKeywordClick(item)}
                >
                  {index < 3 && <span className={styles.hotBadge}>HOT</span>}
                  <span className={styles.itemText}>{item}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <Popover
      content={<History />}
      trigger="click"
      overlayClassName={styles.popover}
      overlayInnerStyle={{
        padding: 0,
        background: 'transparent',
        boxShadow: 'none'
      }}
    >
      <div className="search-wrapper">
        <SearchOutlined className="search-icon" />
        <Input
          className="search-input"
          placeholder="搜索..."
          value={ keyword }
          allowClear
          onChange={ handleKeywordChange }
          onPressEnter={ handleSearch }
          onFocus={() => setShowHistory(true)}
        />
      </div>
    </Popover>
  );
};

export default SearchBarWithHistory;
